/* EISFOREMMANUEL — theme behaviour. No dependencies. */
(function () {
  'use strict';

  /* ---------------------------------------------------- mobile nav drawer */
  var drawer = document.querySelector('[data-drawer]');
  var openBtn = document.querySelector('[data-drawer-open]');
  var closeBtn = document.querySelector('[data-drawer-close]');
  var lastFocus = null;

  function openDrawer() {
    if (!drawer) return;
    lastFocus = document.activeElement;
    drawer.setAttribute('data-open', 'true');
    drawer.removeAttribute('aria-hidden');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    var first = drawer.querySelector('a, button');
    if (first) first.focus();
  }

  function closeDrawer() {
    if (!drawer) return;
    drawer.setAttribute('data-open', 'false');
    drawer.setAttribute('aria-hidden', 'true');
    if (openBtn) openBtn.setAttribute('aria-expanded', 'false');
    document.body.style.overflow = '';
    if (lastFocus) lastFocus.focus();
  }

  if (openBtn) openBtn.addEventListener('click', openDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && drawer && drawer.getAttribute('data-open') === 'true') closeDrawer();
  });

  /* Keep focus inside the open drawer. */
  if (drawer) {
    drawer.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var items = drawer.querySelectorAll('a[href], button:not([disabled])');
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  }

  /* ------------------------------------------------------ quantity steppers */
  document.querySelectorAll('[data-qty]').forEach(function (wrap) {
    var input = wrap.querySelector('input');
    if (!input) return;
    wrap.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.getAttribute('data-step') === 'up' ? 1 : -1;
        var min = parseInt(input.getAttribute('min') || '1', 10);
        var next = (parseInt(input.value, 10) || min) + step;
        input.value = next < min ? min : next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* -------------------------------------------------------- variant picker */
  var form = document.getElementById('ProductForm');
  if (form) {
    var dataEl = document.getElementById('ProductVariants');
    var variants = [];
    try { variants = JSON.parse(dataEl.textContent); } catch (err) { variants = []; }

    var idInput = form.querySelector('[name="id"]');
    var priceEl = document.querySelector('[data-product-price]');
    var submit = form.querySelector('[data-add-to-cart]');

    function selectedOptions() {
      return Array.prototype.map.call(
        form.querySelectorAll('[data-option-index]'),
        function (group) {
          var checked = group.querySelector('input:checked');
          return checked ? checked.value : null;
        }
      );
    }

    function matchVariant(opts) {
      for (var i = 0; i < variants.length; i++) {
        var v = variants[i];
        var hit = true;
        for (var j = 0; j < opts.length; j++) {
          if (opts[j] !== null && v.options[j] !== opts[j]) { hit = false; break; }
        }
        if (hit) return v;
      }
      return null;
    }

    function money(cents) {
      return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    }

    function update() {
      var variant = matchVariant(selectedOptions());

      if (!variant) {
        if (submit) { submit.disabled = true; submit.textContent = 'Unavailable'; }
        return;
      }

      if (idInput) idInput.value = variant.id;

      if (priceEl) {
        priceEl.innerHTML = variant.compare_at_price && variant.compare_at_price > variant.price
          ? '<s>' + money(variant.compare_at_price) + '</s>' + money(variant.price)
          : money(variant.price);
      }

      if (submit) {
        submit.disabled = !variant.available;
        submit.textContent = variant.available ? 'Add to cart' : 'Sold out';
      }

      if (history.replaceState) {
        var url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }

    form.querySelectorAll('[data-option-index] input').forEach(function (input) {
      input.addEventListener('change', update);
    });
    update();
  }

  /* ------------------------------------------------- hero background video */
  var heroVideo = document.querySelector('[data-hero-video]');
  var heroToggle = document.querySelector('[data-hero-toggle]');

  if (heroVideo) {
    var reduceMQ = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    var userPaused = false;   /* true only when the visitor pressed pause themselves */

    function reduced() { return !!(reduceMQ && reduceMQ.matches); }

    function syncToggle() {
      if (!heroToggle) return;
      var paused = heroVideo.paused;
      heroToggle.setAttribute('aria-pressed', paused ? 'true' : 'false');
      heroToggle.setAttribute('aria-label', paused ? 'Play background video' : 'Pause background video');
      var txt = heroToggle.querySelector('[data-toggle-txt]');
      if (txt) txt.textContent = paused ? 'Play' : 'Pause';
    }

    function tryPlay() {
      /* Never override an explicit pause or a reduced-motion preference. */
      if (userPaused || reduced()) return;
      var p = heroVideo.play();
      if (p && typeof p.catch === 'function') p.catch(syncToggle);
    }

    heroVideo.addEventListener('play', syncToggle);
    heroVideo.addEventListener('pause', syncToggle);

    /* Someone who asked their OS for less motion lands on the poster frame,
       not a loop. They can still start it deliberately with the button. */
    if (reduced()) {
      heroVideo.removeAttribute('autoplay');
      heroVideo.pause();
    } else {
      tryPlay();
    }
    syncToggle();

    if (reduceMQ && reduceMQ.addEventListener) {
      reduceMQ.addEventListener('change', function () {
        if (reduced()) heroVideo.pause();
        else tryPlay();
      });
    }

    if (heroToggle) {
      heroToggle.addEventListener('click', function () {
        if (heroVideo.paused) {
          userPaused = false;
          var p = heroVideo.play();
          if (p && typeof p.catch === 'function') p.catch(syncToggle);
        } else {
          userPaused = true;
          heroVideo.pause();
        }
      });
    }

    /* Don't burn a phone's battery decoding video nobody is looking at. */
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) tryPlay();
          else if (!heroVideo.paused) heroVideo.pause();
        });
      }, { threshold: 0.15 }).observe(heroVideo);
    }
  }

  /* ---------------------------------------------- YouTube grid (facade) */
  /* YouTube has no maxres thumbnail for every video. Fall back to hqdefault,
     which always exists, rather than showing a broken image. */
  document.querySelectorAll('img[data-yt-fallback]').forEach(function (img) {
    img.addEventListener('error', function handle() {
      img.removeEventListener('error', handle);
      img.src = img.getAttribute('data-yt-fallback');
    });
  });

  document.querySelectorAll('[data-yt]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var id = btn.getAttribute('data-yt');
      var frameBox = btn.parentNode;
      if (!id || !frameBox) return;

      var iframe = document.createElement('iframe');
      iframe.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(id) +
                   '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
      iframe.title = (btn.getAttribute('aria-label') || 'YouTube video').replace(/^Play video: /, '');
      iframe.allow = 'accelerometer; autoplay; encrypted-media; picture-in-picture; fullscreen';
      iframe.setAttribute('allowfullscreen', '');

      /* Swap, don't nest — the button is gone once the player exists. */
      frameBox.replaceChild(iframe, btn);
      iframe.focus();
    });
  });

  /* ------------------------------------------------- inspection form UX */
  var leadForm = document.getElementById('InspectionForm');
  if (leadForm) {
    leadForm.addEventListener('submit', function () {
      var btn = leadForm.querySelector('[type="submit"]');
      if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
    });
  }
})();
